import ENDPOINTS from 'tradera-constants/endpoints';
import {
    axiosWithTokenRefresh,
    finalizeResponse,
    handleError,
    axiosConfigs
} from 'tradera-utils/api';

export const getCartOverview = async (cartId, countryCode) => {
    return axiosWithTokenRefresh()
        .get(
            `${ENDPOINTS.CART_OVERVIEW_VIEW}/${cartId}?shippingCountryCodeIso2=${countryCode}`,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());
};

export const addItemToCart = async (cartId, itemId, price) => {
    const params = { cartId: cartId, itemId: itemId, price: price };
    return axiosWithTokenRefresh()
        .post(`${ENDPOINTS.CART_ADD_ITEM}`, params, axiosConfigs.authenticated)
        .then(finalizeResponse())
        .catch(handleError());
};

export const removeItemsFromCart = async (cartId, itemIds) => {
    const params = { cartId: cartId, itemIds: itemIds };
    return axiosWithTokenRefresh()
        .post(
            `${ENDPOINTS.CART_REMOVE_ITEMS}`,
            params,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());
};

export const setCartItemQuantity = async (cartId, itemId, quantity) => {
    const params = { cartId: cartId, itemId: itemId, quantity: quantity };
    return axiosWithTokenRefresh()
        .post(
            `${ENDPOINTS.CART_SET_ITEM_QUANTITY}`,
            params,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());
};

export const confirmCartPurchase = async (shopItems, googleAnalyticsData) => {
    const params = {
        shopItems: shopItems,
        googleAnalyticsData: googleAnalyticsData
    };
    return axiosWithTokenRefresh()
        .post(
            `${ENDPOINTS.ORDER_PURCHASE_SHOP_ITEMS}`,
            params,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());
};

export const startOffPlatformCheckout = async itemId => {
    const params = { itemId: itemId };
    return axiosWithTokenRefresh()
        .post(
            `${ENDPOINTS.START_OFF_PLATFORM_CHECKOUT}`,
            params,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());
};

export const createUncommittedPurchaseOrder = async (
    purchaseOrderId,
    sellerMemberId,
    shopItems
) => {
    const params = {
        purchaseOrderId,
        sellerMemberId,
        purchaseOrderItems: shopItems
    };
    return axiosWithTokenRefresh()
        .post(
            `${ENDPOINTS.ORDER_CHECKOUT_CREATE_UNCOMMITTED_PURCHASE_ORDER}`,
            params,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());
};

// Temporary call to make TouchWeb update the cart item count + price. Remove once it's fully moved to React.
export const updateCartSummary = async cartId => {
    const params = { cartId: cartId };
    return axiosWithTokenRefresh()
        .post(
            `${ENDPOINTS.CART_UPDATE_SUMMARY}`,
            params,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());
};

// Export object for Sinon stubbing
export default {
    getCartOverview,
    addItemToCart,
    removeItemsFromCart,
    setCartItemQuantity,
    updateCartSummary,
    confirmCartPurchase,
    startOffPlatformCheckout,
    createUncommittedPurchaseOrder
};
